<div class="container-fluid">
    <div class="row fondoAmarillo">
        <div class="col-lg-2">
            <img src="assets/img/auri.png" height="60px">
        </div>
        <div class="col-lg-8">
            <br>
            <p class="center blanco">¡Bienvenido 
                <!-- <span class="bold">{{dataUsuario.first_name}}</span>! -->
            </p>
        </div>
        <div class="col-lg-2">
            <br>
            <p><a class="blanco bold" (click)="closeSesion()">Cerrar Sesión</a></p>
        </div>
    </div>
    <br><br>
    <div class="row">
        <div class="col-8">
            <h3>Elementos Seleccionados</h3>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <td>Producto</td>
                        <td>Precio</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let seleccion of seleccionesCliente">
                        <td>{{seleccion.paquete}}</td>
                        <td>
                            <span *ngIf="seleccion.precio != 0">{{seleccion.precio | currency}}</span>
                            <span *ngIf="seleccion.precio == 0">-</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-4">
            <div *ngIf="elementosPendientes > 0">
                <h3>Elementos por seleccionar</h3>
            <table class="table table-striped">
                <thead>
                    <td>Concepto</td>
                    <td>Completado</td>
                </thead>
                <tbody>
                    <tr *ngFor="let config of configuracionPaquete">
                        <td>{{config.concepto}}</td>
                        <td>
                            <svg style="color: darkred;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                            </svg>
                            <!-- <span *ngIf="config.seleccionado == 1"> Completado</span> -->
                            <span *ngIf="config.concepto == 'Marco'">
                                <a href="seleccionar-marco/{{currentCliente}}/{{currentGrupo}}/{{currentPaquete}}" class="bold negro"> Elegir</a>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
            
        </div>
    </div>
</div>